import { render, staticRenderFns } from "./CustomConciergeCard.vue?vue&type=template&id=5fc755e4&scoped=true"
import script from "./CustomConciergeCard.vue?vue&type=script&lang=js"
export * from "./CustomConciergeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc755e4",
  null
  
)

export default component.exports